import {useState, useEffect} from 'react';
import { useStyles } from './styles';
import { Box, Button, Grid, TextField, TextareaAutosize, Typography, FormGroup, FormControl, Select, MenuItem, InputLabel, FormControlLabel, Checkbox, CircularProgress } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { decrypt, encrypt } from '../../../helpers/encrypt';
import { checkValidEmail, isAdminCheck, getAppSource, getUserType, checkDigitOnly, renderDefaultMsg } from '../../../helpers';
import { submitRefinanceRequest, getAllStateList } from '../../../actions';
import close from '../../../assets/close.png';
import Cookies from 'js-cookie';

export const CallMeAlert = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [additionalNote, setAdditionalNote] = useState("");
  const [checkboxState, setCheckboxState] = useState(false);
  const [mobileNo, setMobileNo] = useState(props?.userProfile?.mobileNo ? decrypt(props?.userProfile?.mobileNo) : '');
  const [mobileNoErr, setMoileNoError] = useState("");
  const [errorMessage, setErrorMessage] = useState("")
  const [emailId, setEmailId] = useState(props?.userProfile?.emailID ? decrypt(props?.userProfile?.emailID) : '');
  const [emailError, setEmailError] = useState("");
  const [stateData, setStateData] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [stateErrorMsg, setStateErrorMsg] = useState('');
  const [loanState, setLoanState] = useState('');
  const [addDescriptionStatus, setDescriptionStatus] = useState(false);
  const [mandatoryFields, setMandatoryFields] = useState(false);
  const [isSubmit, isSubmitStatus] = useState(false);
  const [loaderStatus, setloaderStatus] = useState(false);
  const selectedAccountData = useSelector(state => state.selectedAccountData);

  useEffect(() => {
    getState();
  }, []);

  const checkboxChangeHandler = (event) => {
    setCheckboxState(event.target.checked)
  }

  const addDescription = () => {
    setDescriptionStatus(!addDescriptionStatus)
  }
  
  const handleMobileNo = (event) => {
    if (checkDigitOnly(event.target.value)) {
     setMobileNo(event.target.value)
    } 
  }

  const handleCommment = (event) => {
    setAdditionalNote(event.target.value)
  }

  const handleCancel= (status) => {
    props.closeCallMePopup(status)
  }

  const handleFormStateChange = (event) => {
    setSelectedState(event.target.value);
  }
 
  const handleConfirm = async () => {
    if (checkValidations()) {
      setMandatoryFields(true)
    } else {
      setloaderStatus(true)
      setMandatoryFields(false)
      const data = {
        "emailId": emailId ? encrypt(emailId) : null,
        "phoneNo": encrypt(mobileNo),
        "propertyState": selectedAccountData.propertyState,
        "newLoanState": ((loanState == "Buy a new home (purchase loan)") || (loanState == "Not sure – need advice")) ? selectedState?.stateCode : null,
        "requestSource": "PostLogin",
        "callbackReason": loanState,
        "isMilitaryVeteran": null,
        "isConsent": checkboxState,
        "description": additionalNote,
        "accountNumber": Cookies.get("selectedAccount"),
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": Cookies.get('publicIp'),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "userName": "",
      };

      const response = await submitRefinanceRequest(data);
      if (response) {
        setloaderStatus(false)
        if (response?.responseData?.lstResponseStatus && (response?.responseData?.lstResponseStatus[0]?.statusCode == 0)) {
          isSubmitStatus(true)
          setErrorMessage("")
        } else {
          setErrorMessage(renderDefaultMsg('400'))
        }
      } else {
        setloaderStatus(false)
        setErrorMessage(renderDefaultMsg('400'))
      }
    }
  }
  
  const calculateCommentLenth = () => {
    const length = additionalNote?.length
    if (isNaN(length)) {
      return 0
    } else {
      return length
    }
  }

  const validateMobileNo = (event) => {
    event.preventDefault()
    if (checkDigitOnly(event.target.value)) {
      if(event.target.value.length === 10) {
        setMoileNoError('');
      } else {
        setMoileNoError('Please enter valid phone number.')
      }
   }
  }

  const validateEmail = (event) => {
    event.preventDefault()
    if (checkValidEmail(event.target.value?.trim())) {
      setEmailError('');
    } else {
      setEmailError('Please enter valid email address.')
    }
  }

  const getState = async (e) => { 
    const response = await getAllStateList();
    if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode == 0) {
      setStateErrorMsg('');
      setStateData(response.stateList);
    } else if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode == 1001) {
      setStateErrorMsg(response.lstResponseStatus[0].statusDesc);
    } else {
      setStateErrorMsg(renderDefaultMsg('400'));
    }
  }

  const checkValidations = () => {
    if ((mobileNo == undefined) || (mobileNo == "") || (mobileNo?.trim().length === 0) || (mobileNoErr !== '') || (loanState == '') || (((loanState == "Buy a new home (purchase loan)") || (loanState == "Not sure – need advice")) && (selectedState == null)) || !checkboxState) {
      return true
    } else {
      return false
    }
  }

  const handleSaveOnLoansChange = (event) => {
    setLoanState(event.target.value)
  }

  const handleEmailId = (event) => {
    setEmailId(event.target.value)
  }

  return (
    
      <Dialog
        open={true}
        fullScreen={fullScreen}
        fullWidth
        maxWidth={false} 
        PaperProps={{
          classes: { root: classes.dialogStyle },
          style: { maxWidth: 'none', width:!isSubmit ? 600 : 540 } 
        }}
      >
      <Box className={classes.root}>
        <IconButton  className={classes.closeIcon} onClick={() => handleCancel(false)}>
          <CancelIcon />
        </IconButton>
         <Box className={classes.cardTitleBody}>
           <Typography className={classes.statusTitle}>Request a Loan Consultation</Typography>
         </Box> 
         { !isSubmit ?
            <Box className={classes.cardBody}>
            <Box>
              <p className={classes.typography}>Save on Loans with Us! What’s your goal?  <span style={{ color: "red" }}>*</span></p>
              <FormControl variant="outlined" className={classes.formControl} style={{ width: '100%' }}>
              <InputLabel id="borrower-type-select-outlined">Select One</InputLabel>
              <Select
                labelId="request-outlined-label"
                id="request-select-outlined"
                color="primary"
                name="request"
                label="Select One"
                className={classes.inputStyle}
                fullWidth
                value={loanState}
                onChange={handleSaveOnLoansChange}
              >
                <MenuItem value="Buy a new home (purchase loan)">Buy a new home (purchase loan)</MenuItem>
                <MenuItem value="Lower my monthly payment">Lower my monthly payment</MenuItem>
                <MenuItem value="Reduce my interest rate">Reduce my interest rate</MenuItem>
                <MenuItem value="Reduce total loan cost">Reduce total loan cost</MenuItem>
                <MenuItem value="Pay off my loan faster">Pay off my loan faster</MenuItem>
                <MenuItem value="Refinance to a better loan">Refinance to a better loan</MenuItem>
                <MenuItem value="Not sure – need advice">Not sure – need advice</MenuItem>
              </Select>
              </FormControl>
            </Box>

            {((loanState == "Buy a new home (purchase loan)") || (loanState == "Not sure – need advice")) && <Box className={classes.textareaSection}>
              <p className={classes.typography}>{(loanState == "Buy a new home (purchase loan)") ? 'Property State for which you are taking new loan' : 'Property State for which you are refinancing or taking new loan'} <span style={{ color: "red" }}>*</span></p>
              <FormControl variant="outlined" className={classes.formControl} style={{ width: '100%'}}>
                <InputLabel id="borrower-type-select-outlined">Select One</InputLabel>
                {stateErrorMsg === '' && <Select
                  labelId="borrower-state-outlined-label"
                  id="borrower-state-select-outlined"
                  name="state"
                  color="primary"
                  label="Select One"
                  className={classes.inputStyle}
                  value={selectedState}
                  onChange={handleFormStateChange}
                  fullWidth >
                  {stateData.length !== 0 && stateData.map((item, index) => {
                    return (
                      <MenuItem value={item} key={(index - 1) + item.stateCode}>{item.stateName}</MenuItem>
                    )
                  })}
                </Select>}
              </FormControl>
            </Box> } 
                  
              <Box className={classes.textareaSection}>
                <TextareaAutosize
                  style={{ height: '70px' }}
                  color="primary"
                  variant="outlined"
                  type="text"
                  name="comments"
                  maxLength="500"
                  onChange={(event) => handleCommment(event)}
                  value={additionalNote}
                  placeholder="Additional Notes (Optional)"
                  className={classes.textArea}
                >
              </TextareaAutosize>
                <Typography className={classes.textAreaValidation}>{calculateCommentLenth()}/500</Typography>
              </Box>

              <Box className={classes.textareaSection}>
                <TextField
                  autoFocus
                  color="primary"
                  variant="outlined"
                  type="text"
                  label={<Box>Phone Number <span style={{color: 'red'}}>*</span></Box>}
                  value={mobileNo}
                  onChange={(event) => {handleMobileNo(event); validateMobileNo(event)}}
                  className={classes.textBox}
                  inputProps={{
                    maxLength: 10
                  }}
                />
                {(mobileNoErr !== '') && <p className={classes.validationError}>{mobileNoErr}</p>}
              </Box>
               <Box className={classes.textareaSection}>
                <TextField
                  autoFocus
                  color="primary"
                  variant="outlined"
                  type="text"
                  label="Email Address (Optional)"
                  value={emailId}
                  onChange={(event) => {handleEmailId(event); validateEmail(event)}}
                  className={classes.textBox}
                />
                 {(emailError !== '') && <p className={classes.validationError}>{emailError}</p>}
              </Box>

              <Box>
              <Box style={{paddingTop: "25px"}}>
                <FormGroup row>
                  <FormControlLabel
                      control={<Checkbox
                      checked={checkboxState}
                      onChange={(event) => checkboxChangeHandler(event)}
                      className={classes.checkboxContainer}
                      name="agree"
                      style={{paddingBottom: "24px"}}
                  />}
                      label={<Typography className={classes.checkBoxLabel}> By checking this Box, you consent to being contacted by BSI for sales or marketing purposes. <span style={{ color: "red" }}>*</span></Typography>}
                      classes={{
                          label: classes.radioLabel
                      }}
                  />
                </FormGroup>
              </Box>     
              { !addDescriptionStatus && <Typography className={classes.viewconsent} onClick={() => addDescription()}>View Consent</Typography>}
              { addDescriptionStatus &&
                  <Box className={classes.infoTopBox}>
                    <Box style={{display: "flex"}}>
                      <Grid container >
                        <Grid item xs={11} md={11}>
                          <Typography className={classes.viewconsent} onClick={() => addDescription()}>Hide Consent </Typography>
                        </Grid>
                        <Grid item xs={1} md={1}>
                          <img src={close} className={classes.icon} onClick={() => addDescription()}/>
                        </Grid>
                      </Grid>
                    </Box>
                    <Typography className={classes.feelFree}>By providing my email address and mobile phone number, I am granting BSI, its subsidiaries, affiliates, partners, service providers, successors and assigns, express consent to contact me at that email address or phone number about my loan, including information regarding servicing and products or services offered by BSI or a joint-marketing partner in connection with my loan. My consent allows BSI to use text messaging, artificial or pre-recorded voice messages and automatic dialing technology, as well as emails, for informational and service calls or messages. Message and data rates may apply.</Typography>
                  </Box>
                } 
            </Box>
            {mandatoryFields && <Typography className={classes.errorMsg}>Please fill * required fields to submit.</Typography>}
            <Typography className={classes.errorMsg}>{errorMessage !== '' ? errorMessage : ''}</Typography>
            
            <Box className={classes.buttonContainer}>
                <Grid container>
                    <Grid container style={{ marginTop: '12px' }}>
                      <Grid item xs={6} md={6}>
                        <Button
                          className={classes.skipBtn}
                          variant="outlined"
                          onClick={() => handleCancel(false)}  
                          >CANCEL</Button>
                        </Grid>
                        <Grid item xs={6} md={6}>
                        <Button type='submit' className={classes.continueBtn} onClick={() => handleConfirm()} disabled={isAdminCheck()} variant="contained" color="primary">
                          { loaderStatus ? <CircularProgress color='primary' /> : 'SUBMIT' }
                        </Button>
                    </Grid>
                  </Grid>
                </Grid>
            </Box>
        </Box> :
         <>
          <Box className={classes.cardBody2}>
             <Typography className={classes.heading}>Thank you! Your request has been received.</Typography>
             <Typography className={classes.eligible}>If you are eligible for refinance or lending options, a member of our lending team will reach out to you.</Typography>
          </Box>
          
          <Box className={classes.gotItButton}>
            <Button
              variant='contained'
              color='primary'
              className={classes.btn}
              onClick={() => handleCancel(false)}
              >Got it</Button>
          </Box> 
          </>
        }
      </Box>
    </Dialog>
  )
}
